import { useQuery } from '@tanstack/react-query';
import { API_URL } from './constants';
import { authHeaders } from './helpers';
import type { PD7A } from './types';

export function usePD7A() {
  return useQuery<PD7A, Error>({
    queryKey: ['payroll-taxes-pd7a-current'],
    queryFn: async () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const r = await fetch(
        API_URL + '/api/v1/payroll/taxes/pd7a?year=' + year + '&month=' + month,
        { headers: authHeaders() },
      );
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json() as Promise<PD7A>;
    },
    refetchOnWindowFocus: false,
  });
}